import { Component, Input } from '@angular/core';
import { ToggleableInputDirective } from '@mhe/ngx-shared/shared';
import { provideValueAccessor } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/required-indicator";
/**
 * @deprecated since version 9.0
 */
export class CheckboxComponent extends ToggleableInputDirective {
    _required = false;
    _inverted = false;
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = typeof value !== 'undefined' && value !== false;
    }
    get inverted() {
        return this._inverted;
    }
    set inverted(value) {
        this._inverted = typeof value !== 'undefined' && value !== false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CheckboxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CheckboxComponent, selector: "mhe-checkbox", inputs: { required: "required", inverted: "inverted" }, providers: [provideValueAccessor(CheckboxComponent)], usesInheritance: true, ngImport: i0, template: "<label class=\"ahe-ui-checkbox\" [class.ahe-ui-checkbox_inverted]=\"inverted\">\n  <input\n    #input\n    type=\"checkbox\"\n    (change)=\"_onChangeEvent($event)\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.required]=\"required ? '' : null\"\n  />\n  <span><ng-content></ng-content></span>\n  <mhe-required-indicator [required]=\"required\" [inverted]=\"inverted\"></mhe-required-indicator>\n</label>\n", styles: ["\n"], components: [{ type: i1.RequiredIndicatorComponent, selector: "mhe-required-indicator", inputs: ["required", "inverted"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ providers: [provideValueAccessor(CheckboxComponent)], selector: 'mhe-checkbox', template: "<label class=\"ahe-ui-checkbox\" [class.ahe-ui-checkbox_inverted]=\"inverted\">\n  <input\n    #input\n    type=\"checkbox\"\n    (change)=\"_onChangeEvent($event)\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.required]=\"required ? '' : null\"\n  />\n  <span><ng-content></ng-content></span>\n  <mhe-required-indicator [required]=\"required\" [inverted]=\"inverted\"></mhe-required-indicator>\n</label>\n", styles: ["/*# sourceMappingURL=checkbox.component.css.map */\n"] }]
        }], propDecorators: { required: [{
                type: Input
            }], inverted: [{
                type: Input
            }] } });
